module.exports = __webpack_public_path__ + "d6f3e41c7172868cfde5acabcd626851.pdf";